module.exports = __webpack_public_path__ + "static/img/A165.61dc30dd.jpg";